import React, { useCallback } from "react";
import { connect } from "react-redux";
import { compose } from 'redux';
import { OAuthProviders, OAuthService } from '../../services/oauth';
import withAPI from '../../services/api';
import { debugLog } from '../../common/utils';
import classlinkMark from '../../assets/images/classlink.png';

const mapStateToProps = (state, ownProps?) => ({
  orgSettings: state.status.userOrgSettings,
});

const LoginWithClassLinkButton = ({ api, linkToExisting }) => {

  function jsonToURI (json) {
    return encodeURIComponent(JSON.stringify(json));
  }

  const handleClassLinkLogin = useCallback(async () => {
    const provider = new OAuthService(OAuthProviders.classlink);
    if (linkToExisting) {
      // Connecting ClassLink to an already-logged-in account: mint a user code
      // and carry it through the OAuth state, same as the Clever flow.
      try {
        debugLog("Linking ClassLink to existing account...");
        api.createUserCode()
        .then((resp) => {
          const state = {
            link_to_existing: true,
            link_code: resp.usercode,
            slug: sessionStorage.getItem('authToken'),
          };
          provider.redirectToLogin({ state: jsonToURI(state) });
        })
        .catch((e) => console.error(e));
      } catch (e) {
        console.error(e);
      }
    } else {
      // Service-provider-initiated login: land on the ClassLink login page,
      // which (finding no code) redirects to ClassLink to start the flow.
      try {
        const url = OAuthProviders.classlink.OAUTH_LOGIN_LAUNCH_PAGE;
        debugLog("Redirecting to:", url);
        window.location.assign(url);
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  return (
    <button id='login_with_classlink'
      type="button"
      onClick={() => { handleClassLinkLogin() }}
    >
      <div className="a">
        <img src={classlinkMark} alt="ClassLink" />
      </div>
      {linkToExisting
      ? <div className="b">
          ClassLink
        </div>
      : <div className="b">
          Log in with ClassLink
        </div>
      }
    </button>
  );
}

export default compose(connect(mapStateToProps), withAPI)(LoginWithClassLinkButton);
